import { useEffect } from "react";

export const SITE_URL = process.env.REACT_APP_BACKEND_URL;

const add = (tag, attrs) => {
  const el = document.createElement(tag);
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  el.setAttribute("data-seo", "1");
  document.head.appendChild(el);
};

export function useSeo({ title, description, path, image, jsonLd }) {
  const ld = JSON.stringify(jsonLd || null);
  useEffect(() => {
    const descEl = document.head.querySelector('meta[name="description"]');
    const prev = { title: document.title, desc: descEl?.getAttribute("content") };
    document.head.querySelectorAll("[data-seo]").forEach((el) => el.remove());
    const url = `${SITE_URL}${path}`;
    document.title = title;
    descEl?.setAttribute("content", description);
    add("link", { rel: "canonical", href: url });
    [["og:title", title], ["og:description", description], ["og:url", url], ["og:type", "website"], ["og:site_name", "Vinsafe"], ...(image ? [["og:image", image]] : [])]
      .forEach(([property, content]) => add("meta", { property, content }));
    add("meta", { name: "twitter:card", content: image ? "summary_large_image" : "summary" });
    if (ld !== "null") {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.text = ld;
      s.setAttribute("data-seo", "1");
      document.head.appendChild(s);
    }
    return () => {
      document.head.querySelectorAll("[data-seo]").forEach((el) => el.remove());
      document.title = prev.title;
      if (prev.desc) descEl?.setAttribute("content", prev.desc);
    };
  }, [title, description, path, image, ld]);
}
